import { get } from 'lodash';

export const getPage = (state) => state.page.name;
export const hasError = (state) => get(state.page, 'hasError', false);
export const fileUploadReviewed = (state) => get(state.page, 'fileUploadReviewed', false);
export const hasFileUploadError = (state) => get(state.page, 'hasFileUploadError', false);
export const fileUploadErrorMessage = (state) => get(state.page, 'fileUploadErrorMessage', '');
export const hasErrorDeadline = (state) => state.page.fileUploadStatus === 409;
export const fileUploadSettlementDate = (state) => get(state.page, 'fileUploadSettlementDate', '');
export const fileUploadSubmissionDate = (state) => get(state.page, 'fileUploadSubmissionDate', '');
